import axios from 'axios';
import type {
  IContactSearchBuyerResponse,
  IContactSearchBuyersRequest,
} from '@bb/contacts';

const getBuyers = async (name: string, agentId?: string) => {
  const config: IContactSearchBuyersRequest = {
    url: '/contacts/search/buyers',
    params: {
      input: name || '',
      agentId: agentId || '',
    },
    method: 'get',
  };

  const { data } = await axios.request<IContactSearchBuyerResponse>(config);
  return data;
};

export default getBuyers;
